import React from "react";
import UserProfileEditorView from "./child-components/UserProfileEditorView";


export const UserProfileContainer = (props: any) => {
    return (<UserProfileEditorView />);
};


